import React from 'react';
import DataTable from '../reporting_utils/DataTable';

const $ = window.$;

export default function EmployeeBreakdownTable({ data }) {
  function buildColumnDefs() {
    /** @type {import('../reporting_utils/DataTable').ColumnDef[]} */
    const columns = [];
    columns.push({ data: 'employeename', title: 'Employee' });
    columns.push({
      data: 'total_calls',
      render: $.fn.dataTable.render.number(','),
      title: 'Total Calls',
      aggregation: 'sum',
    });
    columns.push({
      data: 'total_prospects',
      render: $.fn.dataTable.render.number(','),
      title: 'Total Prospects',
      aggregation: 'sum',
    });
    columns.push({
      data: 'total_sales',
      render: $.fn.dataTable.render.number(','),
      title: 'Sales',
      aggregation: 'sum',
    });
    columns.push({
      data: 'total_service',
      render: $.fn.dataTable.render.number(','),
      title: 'Service',
      aggregation: 'sum',
    });
    columns.push({
      data: 'missed_ops',
      render: $.fn.dataTable.render.number(','),
      title: 'Missed Opps',
      aggregation: 'sum',
    });
    columns.push({
      data: 'appts',
      render: $.fn.dataTable.render.number(','),
      title: 'Appointments',
      aggregation: 'sum',
    });
    columns.push({
      data: 'bookable',
      render: $.fn.dataTable.render.number(','),
      title: 'Bookable Prospects',
      aggregation: 'sum',
    });
    columns.push({
      data: 'appt_conversion',
      className: 'table_percent_bar',
      render(data) {
        if (data) {
          return `
            <div class='bar_label'>${data}%</div>
            <div style='position:relative;' class='bar'>
              <div style='width:${data}%;' class='bar_filler'></div>
            </div>`;
        } else {
          return null;
        }
      },
      title: 'Appointment Conversion',
    });
    return columns;
  }

  return (
    <div className='row row_spacer'>
      <div className='col-xs-12'>
        <div className='report_data_container'>
          <div className='title'>Employee Breakdown</div>
          <DataTable
            columnDefs={buildColumnDefs()}
            data={data}
            showTotalFooter={true}
            title='Employee Breakdown'
            order={[[1, 'desc']]}
          />
        </div>
      </div>
    </div>
  );
}
